module.exports = __webpack_public_path__ + "static/media/poikiliasm_full1.07fa96d4.jpg";